export const routes = {
  home: '/',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  contactLists: '/contact-lists',
  identities: '/identities',
  identitiesCreate: '/identities/new',
  identityDetails: '/identities/[id]',
  identityEdit: '/identities/[id]/edit',
  jobs: '/jobs',
  jobsCreate: '/jobs/new',
  jobDetails: '/jobs/[id]',
  jobEdit: '/jobs/[id]/edit',
  canvassers: '/canvassers',
  media: '/media',
  optouts: '/optouts',
  accounts: '/accounts',
  accountDetails: '/accounts/[id]',
  accountEdit: '/accounts/[id]/edit',
  users: '/users',
  userDetails: '/users/[id]',
};

export const routesWithoutDrawer = [
  routes.jobsCreate,
  routes.jobEdit,
  routes.identityEdit,
];

export const publicRoutes: string[] = [
  routes.login,
  routes.register,
  routes.forgotPassword,
];
